import { z } from 'zod'

const createSchoolFormSchema = z.object({
  nameKk: z.string().min(1, { message: 'Поле не может быть пустым' }),
  nameRu: z.string().min(1, { message: 'Поле не может быть пустым' }),
  bin: z
    .string()
    .min(12, { message: 'Неправильный формат. Убедитесь, что вы вводите правильные 12 цифр.' })
    .max(12, { message: 'Неправильный формат. Убедитесь, что вы вводите правильные 12 цифр.' }),
  katoId: z.uuid(),
})

export { createSchoolFormSchema }
